<div class="mat-snackbar">
  <div class="mat-snackbar-message">
    <span
      inlineSVG="assets/icons/{{ data.type === 'INFO' ? 'Check' : 'Error' }}.svg"
      class="ks-mr-2"
    ></span>
    <span class="ks-label-md ks-font-weight-medium">{{ data.message }}</span>
  </div>
  <div *ngIf="data.showCloseBtn" class="mat-snackbar-close">
    <button
      type="button"
      class="ks-btn-xs ks-btn-icon {{ getCloseColor(data.type) }}"
      (click)="dismiss()"
    >
      <span inlineSVG="assets/icons/Close.svg"></span>
    </button>
  </div>
</div>
